import { DashboardActions } from "../action-types/dashboardActionTypes";

const initialState = {
  defectReportbyVesselData: [],
  defectReportallVesselData: [],
  defectReportallVesselCategoryData: [],
  completedChecklistCount: [],
  dashboardUnreadDefectData: [],
};

const deffectReportByVesselReducer = (state = initialState, action) => {
  switch (action.type) {
    case DashboardActions.SET_DASHBOARD_DEFECT_REPORT_LIST:
      return {
        ...state,
        defectReportbyVesselData: action.payload,
      };
    case DashboardActions.SET_COMPLETE_CHECK_LIST_COUNT_LIST:
      return {
        ...state,
        completedChecklistCount: action.payload,
      };
    case DashboardActions.SET_DASHBOARD_DEFECT_REPORT_ALL_VESSEL_LIST:
      return {
        ...state,
        defectReportallVesselData: action.payload,
      };
    case DashboardActions.SET_DASHBOARD_DEFECT_REPORT_ALL_VESSEL_CATEGORY_LIST:
      return {
        ...state,
        defectReportallVesselCategoryData: action.payload,
      };
    case DashboardActions.SET_DASHBOARD_UNREAD_DEFECT_LIST:
      return {
        ...state,
        dashboardUnreadDefectData: action.payload,
      };
    default:
      return state;
  }
};

export default deffectReportByVesselReducer;
